import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

export interface GraphMenuProps {
  /** The title to display at the top of the menu*/
  title: string;
  /** A list of GraphMenuSection components */
  children?: React.ReactNode;
}

/**
 * A menu for changing options on a graph
 */
export const GraphMenu = ({ title, children }: GraphMenuProps): JSX.Element => {
  return (
    <MenuWrapper role="menu" aria-label="chart menu">
      <MenuHeading>{title}</MenuHeading>
      <SectionsWrapper>{children}</SectionsWrapper>
    </MenuWrapper>
  );
};

const MenuWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  width: 276px;
  min-height: 171px;
  max-height: 400px;
  overflow: hidden;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.palette.background.paper};

  border: 1px solid #9e9e9e;
  border-radius: 5px 0 0 5px;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 rgba(0, 0, 0, 0);

  /* Chrome etc. */
  ::-webkit-scrollbar {
    width: 14px;
  }

  ::-webkit-scrollbar-thumb {
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0;
    background-color: #cecece;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #c1c1c1;
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #939393;
  }
`;

const MenuHeading = ({
  children
}: React.PropsWithChildren<{}>): JSX.Element => {
  return <StyledTypography variant="subtitle1">{children}</StyledTypography>;
};

const StyledTypography = styled(Typography)`
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
`;

const SectionsWrapper = styled("div")`
  > * {
    border-bottom: 1px solid #d9d9d9;

    :last-child {
      border-bottom: 0;
    }
  }
`;
